<template lang="pug">
div.margin-bottom-0.col-12(v-if="hasCompetence && (typeNode === 'brand' || typeNode === 'center')")
    skeleton-card(v-if="isLoading")
    v-card.gridFull.ma-0(v-if="!isLoading && dataValorationLastYearFilteredByBrand.length")
        .d-flex.headTitleGrid
            .block-title.titleGrid
                span.mb-0.title-card #[translate Valoración. Evolución anual]
            .block-help.ml-auto
                v-tooltip(left color="#222226" open-on-click=true max-width="550" nudge-top="20" nudge-left="10" content-class="tooltip-help tooltip-help-left")
                    template(v-slot:activator="{ on, attrs }")
                        img(:src="imgCommons.help" v-bind="attrs" v-on="on")
                    div
                        p.mb-0.pb-0 #[translate En función de los filtros seleccionados, se muestra la evolución de los datos de la marca frente a sus competidores: Valoración evolución anual.]

        box-competence-last-year(:chartData="dataValorationLastYearFilteredByBrand" x-axis-key="rating_global")
</template>

<script>
import SkeletonCard from '@/components/common/skeletonCard.vue'
import SrvNetwork from '@/services/network.js'
import commonMixins from "@/mixins/common.js"
import brandMixin from "@/mixins/brand.js"
import BoxCompetenceLastYear from '@/components/network/CompetenceLastYear.vue'
import BoxFeelingCategory from '@/components/global/FeelingCategory.vue'
import FilterTreeMenu from "@/components/filters/filterTreeMenu"
import InfoCompetence from "@/components/competence/InfoCompetence.vue"

export default {
    mixins: [commonMixins, brandMixin],
    components: { InfoCompetence, FilterTreeMenu, BoxFeelingCategory, SkeletonCard, BoxCompetenceLastYear },
    data() {
        return {
            dataValorationLastYear: [],
            valorationBrandsSelected: [],
            filterContainerHeight: 0,
            maxWidth: 0
        }
    },
    created() {
        if (this.$store.getters.getNode > 0) {
            if (this.hasCompetence && ['brand', 'center'].includes(this.typeNode)) {
                this.getCompetenceLastYear()
            }
        }
    },
    expose: ['setFilteredBrands'],
    methods: {
        setFilteredBrands(brands) {
            this.valorationBrandsSelected = [...brands]
        },
        getCompetenceLastYear() {
            SrvNetwork.getCompetenceLastYear()
                .then(res => {
                    if (res.status === 200) {
                        this.dataValorationLastYear = res.data.map((e) => ({ ...e, show: true }))
                    }
                }, () => {
                })
        },
    },
    watch: {},
    computed: {
        brandsValorationActive() {
            return this.valorationBrandsSelected.map(c => c.value || c.code)
        },
        dataValorationLastYearFilteredByBrand() {
            let brands = this.dataValorationLastYear
            if (this.valorationBrandsSelected.length > 0) {
                brands = this.dataValorationLastYear.filter((b) => {
                    if (this.brandsValorationActive.includes(b.name)) {
                        return b
                    }
                })
                brands = [this.dataValorationLastYear[0], this.dataValorationLastYear[1], ...brands]
            }
            console.log(brands)
            if (this.isAdverbia) {
              brands = brands.map(e => {
                e.monthly_reviews.map( x => {
                  x.rating_global = x.rating_global / 2
                  return x
                })
                return e
              })
            }
            return brands
        },
    },
}
</script>

<style lang="scss" scoped></style>
